import { notification } from 'antd';
import { postRequest } from 'api/apiClient';
import { OpButton } from 'components/customAntd/DLS/OpButton/OpButton';
import { IOnSubmitArgs, OpForm } from 'components/customAntd/DLS/OpForm/OpForm';
import { OpSection } from 'components/customAntd/DLS/OpSection/OpSection';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { useConfirmModal } from 'utils/customHooks/useConfirmModal';

interface CheckrInstallProps {
    setIsCheckrInstallOpen: (open: boolean) => void;
    setIsCheckrInstalled: (open: boolean) => void;
}

const CheckrInstall: React.FC<CheckrInstallProps> = ({ setIsCheckrInstallOpen, setIsCheckrInstalled }) => {
    const orgId = useSelector((state: RootState) => state.globalOrg.globalOrgId);
    const [form] = OpForm.useForm();
    const confirmModal = useConfirmModal();
    const { t } = useTranslation();

    const handleSubmit = (async ({ values }: IOnSubmitArgs) => {
        try {
            await postRequest(`/orgs/${orgId}/integrationCheckrTrust`, values);

            notification.success({
                message: t('notification.success'),
                description: t('integration.notification.checkrInstallSuccess'),
                placement: 'bottomRight',
            });
            setIsCheckrInstalled(true);
            setIsCheckrInstallOpen(false);
        } catch (error) {
            notification.error({
                message: t('integration.notification.connectionFailed'),
                description: t('integration.notification.saveError'),
                placement: 'bottomRight'
            });
        }
    });

    const handleCancel = () => {
        confirmModal({
            title: t('integration.confirmCancelCheckr.title'),
            content: t('integration.confirmCancelCheckr.message'),
            okText: t('integration.confirmCancelCheckr.ok'),
            cancelText: t('integration.confirmCancelCheckr.cancel'),
            onOk: () => {
                setIsCheckrInstallOpen(false); // Go back to the main menu
            },
        });
    };
    return (
        <>
            <OpSection>
                <OpForm
                    form={form}
                    onSubmit={handleSubmit}
                    initialValues={{}}
                    defaultButtons={false}
                    hasError={false}
                >
                    <OpForm.Input
                        name="clientId"
                        label={t('integration.checkr.install.clientId')}
                        rules={[{ required: true, message: t('integration.checkr.install.clientIdRequired') }]}
                        placeholder={t('integration.checkr.install.clientIdPlaceholder')}
                    />
                    <OpForm.Input
                        name="clientSecret"
                        label={t('integration.checkr.install.clientSecret')}
                        rules={[{ required: true, message: t('integration.checkr.install.clientSecretRequired') }]}
                        placeholder={t('integration.checkr.install.clientSecretPlaceholder')}
                    />
                </OpForm>
            </OpSection>
            <OpButton type="primary" htmlType="submit" onClick={form.submit}>
                {t('integration.checkr.install.done')}
            </OpButton>
            <OpButton style={{ margin: '0 8px' }} onClick={handleCancel}>
                {t('integration.checkr.install.cancel')}
            </OpButton>
        </>
    );
};

export default CheckrInstall;